<template lang="pug">
.eventos
  //- ============ CABEÇALHO ============
  header.eventos__hero
    .eventos__hero-grid
    .eventos__hero-glow.eventos__hero-glow--blue
    .eventos__hero-glow.eventos__hero-glow--red
    .eventos__hero-inner
      p.eventos__eyebrow
        span.eventos__eyebrow-pip
        | Calendário da temporada
      h1.eventos__title Eventos
      p.eventos__sub Todas as etapas da liga: passadas, em andamento e futuras.
      ul.eventos__stats(v-if="todos.length")
        li.eventos__stat(
          v-for="s in stats"
          :key="s.key"
          :class="'eventos__stat--' + s.key"
        )
          strong {{ s.value }}
          span {{ s.label }}

  //- ============ GRUPOS ============
  .eventos__wrap
    section.eventos__group(v-for="g in grupos" :key="g.key")
      h2.eventos__group-title
        span.eventos__dot(:class="'eventos__dot--' + g.dot")
        | {{ g.titulo }}
        span.eventos__count {{ g.itens.length }}
      .eventos__items
        article.evcard(
          v-for="ev in g.itens"
          :key="ev.id"
          :class="'evcard--' + g.dot"
          @click="abrir(ev)"
        )
          .evcard__date
            span.evcard__day {{ dia(ev) }}
            span.evcard__mon {{ mes(ev) }}
          .evcard__body
            .evcard__row
              span.evcard__when
                span.evcard__when-dot(v-if="g.dot === 'live'")
                FontAwesomeIcon.evcard__when-ic(v-else :icon="['far','clock']")
                | {{ relativo(ev) }}
              span.evcard__test(v-if="ev.is_test") Teste
            h3.evcard__name {{ ev.name }}
            .evcard__metas
              span.evcard__meta(v-if="periodo(ev)")
                FontAwesomeIcon.evcard__ic(:icon="['far','calendar-alt']")
                | {{ periodo(ev) }}
              span.evcard__meta(v-if="ev.address")
                FontAwesomeIcon.evcard__ic(:icon="['fas','map-marker-alt']")
                | {{ ev.address }}
          span.evcard__link
            span.evcard__link-text Abrir
            FontAwesomeIcon.evcard__link-ic(:icon="['fas','arrow-right']")

    .eventos__empty(v-if="!grupos.length")
      FontAwesomeIcon.eventos__empty-ic(:icon="['far','calendar']")
      p Nenhum evento cadastrado ainda.
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { statusOf, relativeLabel } from '@/utils/eventDate'

const MESES = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']

export default {
  name: 'Eventos',
  created () {
    this.setEvents()
  },
  computed: {
    ...mapGetters('events', ['getVisibleEvents']),
    todos () {
      return this.getVisibleEvents || []
    },
    acontecendo () {
      return this.todos
        .filter(e => this.statusOf(e) === 'live')
        .sort((a, b) => new Date(a.startat || 0) - new Date(b.startat || 0))
    },
    emBreve () {
      return this.todos
        .filter(e => this.statusOf(e) === 'scheduled')
        .sort((a, b) => new Date(a.startat || 0) - new Date(b.startat || 0))
    },
    jaAconteceram () {
      return this.todos
        .filter(e => this.statusOf(e) === 'done')
        .sort((a, b) => new Date(b.endat || 0) - new Date(a.endat || 0))
    },
    grupos () {
      const g = []
      if (this.acontecendo.length) g.push({ key: 'live', dot: 'live', titulo: 'Acontecendo agora', itens: this.acontecendo })
      if (this.emBreve.length) g.push({ key: 'scheduled', dot: 'scheduled', titulo: 'Vão acontecer', itens: this.emBreve })
      if (this.jaAconteceram.length) g.push({ key: 'done', dot: 'done', titulo: 'Já aconteceram', itens: this.jaAconteceram })
      return g
    },
    stats () {
      return [
        { key: 'total', value: this.todos.length, label: 'Eventos' },
        { key: 'live', value: this.acontecendo.length, label: 'Ao vivo' },
        { key: 'scheduled', value: this.emBreve.length, label: 'Agendados' },
        { key: 'done', value: this.jaAconteceram.length, label: 'Encerrados' }
      ]
    }
  },
  methods: {
    ...mapActions('events', ['setEvents', 'setCurrentEventId']),
    // Status e texto relativo comparam DIA DE CALENDÁRIO (ver utils/eventDate).
    statusOf (e) {
      return statusOf(e)
    },
    relativo (e) {
      return relativeLabel(e)
    },
    periodo (e) {
      const ini = this.formatDate(e.startat)
      const fim = this.formatDate(e.endat)
      if (ini && fim) return `${ini} a ${fim}`
      return ini || fim
    },
    // Datas de evento são dia de calendário gravado como meia-noite UTC: sempre
    // ler em UTC (getters locais devolviam o dia anterior em UTC-3).
    dia (e) {
      if (!e.startat) return '--'
      const d = new Date(e.startat)
      return isNaN(d.getTime()) ? '--' : String(d.getUTCDate()).padStart(2, '0')
    },
    mes (e) {
      if (!e.startat) return ''
      const d = new Date(e.startat)
      return isNaN(d.getTime()) ? '' : MESES[d.getUTCMonth()]
    },
    formatDate (value) {
      if (!value) return ''
      const d = new Date(value)
      if (isNaN(d.getTime())) return ''
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getUTCDate())}/${pad(d.getUTCMonth() + 1)}/${d.getUTCFullYear()}`
    },
    abrir (e) {
      this.setCurrentEventId(e.id)
      this.$router.push('/EventoDetalhe')
    }
  }
}
</script>

<style lang="sass" scoped>
$blue: #287AED
$blue-dark: #0F4FA8
$red: #DD3434
$green: #2E9E4F
$green-dark: #1F7C3C
$ink: #0B0E14
$muted: #5C6673
$line: rgba(11, 14, 20, 0.10)
$paper: #FFFFFF
$mist: #EEF1F6
$page: #F2F4F8

$display: 'Saira Condensed', 'Lato', sans-serif
$mono: 'Space Mono', 'Lato', monospace

.eventos
  color: $ink
  background: $page
  min-height: calc(100vh - 64px)

  *
    box-sizing: border-box

  // ---------- CABEÇALHO ----------
  &__hero
    position: relative
    overflow: hidden
    isolation: isolate
    padding: 54px 0 60px
    background: radial-gradient(circle at 16% 8%, #15233b 0%, $ink 52%, #05070b 100%)
    color: #fff

  &__wrap
    max-width: 1140px
    margin: 0 auto
    padding: 38px 24px 64px

  &__hero-grid
    position: absolute
    inset: 0
    background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
    background-size: 42px 42px
    mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    -webkit-mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    z-index: -2

  &__hero-glow
    position: absolute
    width: 360px
    height: 360px
    border-radius: 50%
    filter: blur(110px)
    opacity: 0.5
    z-index: -1
    &--blue
      background: $blue
      top: -150px
      left: -90px
    &--red
      background: $red
      bottom: -180px
      right: -80px

  &__hero-inner
    position: relative
    max-width: 1140px
    margin: 0 auto
    padding: 0 24px
    > *
      animation: ev-rise .6s cubic-bezier(.2, .7, .2, 1) both
    .eventos__eyebrow
      animation-delay: .04s
    .eventos__title
      animation-delay: .10s
    .eventos__sub
      animation-delay: .16s
    .eventos__stats
      animation-delay: .22s

  &__eyebrow
    display: inline-flex
    align-items: center
    gap: 10px
    font-family: $mono
    text-transform: uppercase
    letter-spacing: 0.22em
    font-size: 12px
    font-weight: 700
    color: rgba(255, 255, 255, 0.7)
    margin: 0 0 14px

  &__eyebrow-pip
    width: 8px
    height: 8px
    border-radius: 50%
    background: linear-gradient(135deg, #5AA0FF, $red)
    box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.18)

  &__title
    font-family: $display
    font-weight: 800
    text-transform: uppercase
    font-size: clamp(40px, 6vw, 66px)
    line-height: 0.94
    letter-spacing: -0.015em
    margin: 0

  &__sub
    font-size: 17px
    color: rgba(255, 255, 255, 0.74)
    margin: 16px 0 0
    max-width: 540px

  &__stats
    list-style: none
    display: flex
    flex-wrap: wrap
    gap: 16px 28px
    padding: 26px 0 0
    margin: 30px 0 0
    border-top: 1px solid rgba(255, 255, 255, 0.12)

  &__stat
    display: flex
    flex-direction: column
    strong
      font-family: $display
      font-weight: 700
      font-size: 30px
      line-height: 1
      color: #fff
    span
      font-family: $mono
      font-size: 10px
      letter-spacing: 0.12em
      text-transform: uppercase
      color: rgba(255, 255, 255, 0.55)
      margin-top: 8px
    &--live strong
      color: #5BD17F
    &--scheduled strong
      color: #6FB0FF
    &--done strong
      color: #AEB6C2

  // ---------- GRUPOS ----------
  &__group
    margin-bottom: 40px

  &__group-title
    display: flex
    align-items: center
    gap: 12px
    font-family: $display
    text-transform: uppercase
    letter-spacing: 0.01em
    font-size: 22px
    font-weight: 700
    margin: 0 0 18px

  &__dot
    width: 11px
    height: 11px
    border-radius: 50%
    flex-shrink: 0
    &--live
      background: $green
      animation: ev-pulse 1.9s ease-in-out infinite
    &--scheduled
      background: $blue
      box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.16)
    &--done
      background: #9AA1AC

  &__count
    font-family: $mono
    font-size: 12px
    font-weight: 700
    color: $muted
    background: $mist
    border-radius: 999px
    padding: 2px 10px

  &__items
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 360px), 1fr))
    gap: 14px

  &__empty
    display: flex
    flex-direction: column
    align-items: center
    text-align: center
    gap: 14px
    padding: 56px 24px
    background: $paper
    border: 1px dashed rgba(11, 14, 20, 0.18)
    border-radius: 16px
    &-ic
      font-size: 38px
      color: $blue
    p
      font-size: 17px
      color: $muted
      margin: 0

.evcard
  position: relative
  display: flex
  align-items: center
  gap: 18px
  padding: 18px 20px
  background: $paper
  border: 1px solid $line
  border-left: 4px solid #9AA1AC
  border-radius: 14px
  cursor: pointer
  animation: ev-rise .5s cubic-bezier(.2, .7, .2, 1) both
  transition: transform .22s ease, box-shadow .22s ease, border-color .22s ease
  &:nth-child(2)
    animation-delay: .05s
  &:nth-child(3)
    animation-delay: .10s
  &:nth-child(4)
    animation-delay: .15s
  &:nth-child(5)
    animation-delay: .20s
  &:nth-child(n+6)
    animation-delay: .25s
  &:hover
    transform: translateY(-4px)
    box-shadow: 0 18px 38px rgba(11, 14, 20, 0.12)
    .evcard__link
      color: $blue
    .evcard__link-ic
      transform: translateX(4px)
    .evcard__date
      transform: scale(1.04)

  &--live
    border-left-color: $green
  &--scheduled
    border-left-color: $blue
  &--done
    border-left-color: #9AA1AC
    background: #FCFCFD

  &__date
    flex-shrink: 0
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    width: 66px
    height: 66px
    border-radius: 12px
    color: #fff
    background: linear-gradient(150deg, #6B7280, #434B57)
    transition: transform .22s ease
  &--live &__date
    background: linear-gradient(150deg, $green, $green-dark)
  &--scheduled &__date
    background: linear-gradient(150deg, $blue, $blue-dark)

  &__day
    font-family: $display
    font-weight: 800
    font-size: 28px
    line-height: 1
  &__mon
    font-family: $mono
    font-size: 10px
    font-weight: 700
    letter-spacing: 0.14em
    margin-top: 4px
    opacity: 0.9

  &__body
    flex: 1 1 auto
    min-width: 0
    display: flex
    flex-direction: column
    gap: 6px

  &__row
    display: flex
    align-items: center
    flex-wrap: wrap
    gap: 8px

  &__when
    display: inline-flex
    align-items: center
    gap: 7px
    font-family: $mono
    font-size: 10px
    font-weight: 700
    letter-spacing: 0.08em
    text-transform: uppercase
    padding: 3px 9px
    border-radius: 999px
    background: rgba(92, 102, 115, 0.12)
    color: $muted
  &--live &__when
    background: rgba(46, 158, 79, 0.12)
    color: $green-dark
  &--scheduled &__when
    background: rgba(40, 122, 237, 0.12)
    color: $blue-dark

  &__when-ic
    font-size: 10px

  &__when-dot
    width: 7px
    height: 7px
    border-radius: 50%
    background: $green
    animation: ev-pulse 1.6s ease-in-out infinite

  &__test
    font-family: $mono
    font-size: 9px
    font-weight: 700
    text-transform: uppercase
    letter-spacing: 0.1em
    padding: 3px 8px
    border-radius: 999px
    color: #fff
    background: $red

  &__name
    font-family: $display
    text-transform: uppercase
    font-size: 21px
    font-weight: 700
    line-height: 1.08
    margin: 0
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

  &__metas
    display: flex
    flex-wrap: wrap
    gap: 4px 16px

  &__meta
    display: inline-flex
    align-items: center
    gap: 7px
    max-width: 100%
    color: $muted
    font-size: 13px
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  &__ic
    color: $red
    font-size: 12px
    flex-shrink: 0

  &__link
    flex-shrink: 0
    display: inline-flex
    align-items: center
    gap: 8px
    font-family: $mono
    font-size: 11px
    font-weight: 700
    letter-spacing: 0.06em
    text-transform: uppercase
    color: #C4C9D2
    transition: color .22s ease
  &__link-ic
    font-size: 11px
    transition: transform .22s ease

// ---------- animações ----------
@keyframes ev-rise
  from
    opacity: 0
    transform: translateY(16px)
  to
    opacity: 1
    transform: none

@keyframes ev-pulse
  0%
    box-shadow: 0 0 0 0 rgba(46, 158, 79, 0.5)
  70%
    box-shadow: 0 0 0 7px rgba(46, 158, 79, 0)
  100%
    box-shadow: 0 0 0 0 rgba(46, 158, 79, 0)

// ---------- responsivo ----------
@media (max-width: 620px)
  .eventos__hero
    padding: 38px 0 44px
  .eventos__hero-inner
    padding: 0 18px
  .eventos__wrap
    padding: 28px 18px 48px
  .eventos__stats
    gap: 14px 22px
  .eventos__stat strong
    font-size: 26px
  .evcard
    gap: 14px
    padding: 16px

@media (max-width: 520px)
  .evcard__date
    width: 58px
    height: 58px
  .evcard__day
    font-size: 24px
  .evcard__link-text
    display: none
</style>
